export default __webpack_public_path__ + "static/media/file-arrow-up-down.8c6c9751.svg";